import React, { Component } from "react"
import Service from '../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';

import { BasicLazyParams, trimObj, warningDailogInit } from '../../utile';
import _ from 'lodash';
import { AcademicSessionCalIcon, AddIcon2, AssignFormIcon, CalenderIcon, ClassetEditIcon, CodeLinkIcon, CrossInBox, DeleteIconClasset, DeleteIconClassetFull, InfoIcon, MailIcon, MoneyIcon, } from '../svgIcons';
import { baseUrlAdmin, baseUrlForLongRunningTask, } from '../../store/apiConstants';
import ClassetDropdown from "../../classetComponents/classetDropDown";
import ClassetInputText from "../../classetComponents/classetInputText";
import ClassetMultiSelect from "../../classetComponents/classetMultiSelect";
import { paymentTerms, paymentModes } from "../../constants";
import { getFormFields, onTextChange, onDropDownChange, onToggleChange, isFormValid, onChoiceChange, isFieldValid } from "../../utile/formHelper";
import BranchToSectionDD from "../BaseDropdownComponents/BranchToSectionDD";
import ClassetTextArea from "../../classetComponents/classetTextArea";
import InputTextB from "../customComponents/inputTextB";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import FileUploadLambda from "../fileUpload/fileUploadLambda";
import AttachPreviewDelete from "../questionBank/common/attachPreviewDelete";
import reactStringReplace from "react-string-replace";
import CkEditorComponent from "../questionBank/common/ckEditor";
import notification from "../notification";
import moment from "moment/moment";
import LoadingComponent from '../loadingComponent';
import { getImageUrl } from "../../store/actions";
import Authentication from '../session';
import withRouter from '../lib/withRouter';
import NotificationHistory from './NotificationHistory';
import './NotificationHistory.css';

const NotificationTypes = [
    { label: 'General', value: 'General' },
    { label: 'Academic', value: 'Academic' },
    { label: 'Event', value: 'Event' },
    { label: 'Announcement', value: 'Announcement' },
    { label: 'Emergency', value: 'Emergency' },
    { label: 'Reminder', value: 'Reminder' },
    { label: 'Calendar', value: 'Calendar' },
    { label: 'MockTest Report', value: 'MockTest Report' }
];
const imagesBucket = process.env.REACT_APP_IMAGES_BUCKET || 'classetimage-old';
const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';

const NOTIFICATION_MODES = {
    SMS: 'sms',
    ALERT: 'alert',
    EMAIL: 'email',
    WHATS_APP: 'whatsapp'
}

var formFields = require('./createNotification.json');
class ComNotification extends Component {
    constructor(props) {
        super(props);
        this.formFields = getFormFields(formFields);
        this.state = {
            feeTypes: [],
            feeTypeFormData: {},
            lazyParams: BasicLazyParams,
            feeTypeDataTable: true,
            isDialogOpenForCreateNotification: false,
            feeStructureAssignDialog: false,
            editDialog: false,
            feeCategoriesOptions: [],
            admissionCategories: [],
            //--
            notification: this.props?.editData?._id ? this.props?.editData : this.formFields.data,
            formValidations: this.formFields.formValidations,
            warningDialog: warningDailogInit,
            totalRecords: 0,
            globalSearch: '',
            currentStep: 0,
            filterData: null,
            textMsgs: {},
            smsTemplates: [],
            whatsAppTemplates: [],
            isTemplatesRequested: false,
            smsTemplateContent: "",
            whatsAppTemplateBody: "",
            columns: [
                { columnName: 'No of Users', isVisible: true, id: 'usersCount' },
            ],
            editNofication: null,
            notificationsData: [], dropdownsData: {},
            isRejectDialogOpen: false,
            status: "APPROVE",
            notificationHistoryDialog: false,
            selectedNotification: null,
            selectedAlertRecipients: []

        }

        this.service = new Service()
    }

    onGlobalSearch = (e) => {
        this.setState((prevState) => {
            return {

                globalSearch: e.target.value,
                lazyParams: BasicLazyParams
            }
        }, this.getNotifications);
    }

    onPage = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getNotifications);
    }

    onSort = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getNotifications);
    }

    onFilter = (event) => {

        event['first'] = 0;
        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    filters: event.filters
                }
            };
        }, this.getNotifications);
    }
    getNotifications = () => {
        this.setState({
            isLoading: true
        });
        let { lazyParams, globalSearch, status } = this.state;

        const url = `${baseUrlAdmin}/notification-manager?status=${status}&limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}${lazyParams.sortField ? `&sort=${lazyParams.sortOrder == 1 ? '' : '-'}${lazyParams.sortField}` : ''}`;
        this.service.get(url, true).then(res => {

            if (res && res.res && res.res.status) {
                this.setState({
                    notificationsData: res.res.data,
                    totalRecords: res.res.totalRecords,
                    isLoading: false
                });
                //this.toast?.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });

            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
            //  console.log(res);


        }).catch(e => {
            console.log(e);
            this.setState({
                isLoading: false
            });

            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
        })

    }

    componentDidMount() {
        //this.getAdmissionCategoryOptions()
        //this.getFeeCategoryOptions();
        this.getNotifications();
        this.getTemplates();
        this.getWhatsAppTemplates();

    }

    getTemplates = () => {
        this.setState({
            isLoading: true,
            smsTemplates: [],
        });
        let { lazyParams, globalSearch } = this.state;


        let url = `${baseUrlAdmin}/smstemplate/all`;
        this.service.get(url, true).then(res => {

            if (res && res.status && res.res.status) {
                this.setState((prevState) => {
                    return {
                        smsTemplates: res.res.data,
                        isLoading: false
                    };
                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }

    getWhatsAppTemplates = () => {
        this.setState({
            isLoading: true,
            // whatsAppTemplates: [],
        });
        let { lazyParams, globalSearch } = this.state;


        let url = `${baseUrlAdmin}/whatsapptemplate/all`;
        this.service.get(url, true).then(res => {

            if (res && res.status && res.res.status) {
                this.setState((prevState) => {
                    return {
                        whatsAppTemplates: res.res.data,
                        isLoading: false
                    };
                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }

    handleOpenCreate = () => {
        this.setState({ isDialogOpenForCreateNotification: true, editDialog: false, notification: {} })
    }
    onHideCreateFeeDialog = () => {
        this.setState({
            isDialogOpenForCreateNotification: false,
            notification: {}
        })
    }
    _afterFilesUploaded = (files) => {

    }

    _onAttachSuccess = (fieldName) => (fileName, data) => {
        this.props.getImageUrl(data.imageStorageKey);
        this.addAttachment(fieldName, fileName, data);
    }

    addAttachment = (fieldName, fileName, data) => {
        let notification = {
            ...this.state.notification,
            [fieldName]: data.imageStorageKey,
            [fieldName + 'FileName']: fileName
        }

        let formValidations = isFieldValid(formFields.find(fm => fm.FieldName == fieldName), this.state.formValidations, notification);


        this.setState((prevState) => {
            return {
                notification,
                formValidations
            }
        });

        // Show success message
        this.toast?.show({
            severity: 'success',
            summary: 'Success',
            detail: `File "${fileName}" uploaded successfully`,
            life: 3000
        });
    }


    removeAttach = (fieldName) => {
        this.setState((prevState) => {
            return {
                notification: {
                    ...prevState.notification,
                    [fieldName]: '',
                    [fieldName + 'FileName']: ''
                }
            };
        });

    }
    onEdit = (rowData) => {
        // Set the notification first with rowData
        this.setState({ isDialogOpenForCreateNotification: true, editDialog: true, notification: rowData, editNofication: rowData }, () => {
            // Then update template data in the callback to ensure state is set first
            if (rowData.smsTemplateId) {
                this.onMessageTemplateChange('smsTemplateId', rowData.smsTemplateId)
            } else if (rowData.whatsAppTemplateId) {
                this.onWhatsAppTemplateChange('whatsAppTemplateId', rowData.whatsAppTemplateId)
            }
        })
    }
    handleShare = (rowData) => {
        this.setState({
            feeStructureAssignDialog: true,
            editNofication: rowData,
        });
    }
    onHideAssignDialog = () => {
        this.setState({
            feeStructureAssignDialog: false,
            categoryAssignInfo: [],
            selectedCategoryAssignInfo: [],
            selectAll: false,
            selectedAlertRecipients: [],
            dropdownsData: {}
        })
    }

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData,
        }, () => { this.getFeeCategoryAssignInfo(dropdownsData.branchId, dropdownsData.boardId, dropdownsData.classId, dropdownsData.sectionId) })
    }
    getFeeCategoryAssignInfo = (branchId, boardId, classId, sectionId) => {

        if (!branchId || !boardId) {
            this.setState({
                categoryAssignInfo: [],
                selectedCategoryAssignInfo: []
            });
            return;
        }

        this.setState({
            isLoading: true
        });
        const AcademicYear = localStorage.getItem('userAcademicYear')
        let payload = {
            "branchId": branchId,
            "boardId": boardId,
            "classId": classId,
            "sectionId": sectionId,
            "feeStructureId": this.state?.feeStructureDetails?._id

        }
        payload.academicYear = AcademicYear
        let url = `${baseUrlAdmin}/fee-structure/assignInfo`;
        this.service.post(url, payload, true).then(data => {
            if (data.status) {
                this.setState({
                    categoryAssignInfo: data?.res?.data || [],
                    isLoading: false
                })
            } else {
                this.setState({
                    isLoading: false,
                    categoryAssignInfo: []
                })
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching the fee Category Assigninformation', life: 3000 });

            }
        }).catch(error => {
            console.error('API Error:', error);
            this.setState({
                isLoading: false,
                categoryAssignInfo: []
            });
            this.toast?.show({ severity: 'error', summary: 'Error', detail: error.message || 'Failed to fetch data', life: 3000 });
        });

    }
    onSelectAllChange = (event) => {
        const selectAll = event.checked;
        if (selectAll) {
            this.setState({
                selectedCategoryAssignInfo: this.state.categoryAssignInfo,
                selectAll: true
            })
        } else {
            this.setState({
                selectedCategoryAssignInfo: [],
                selectAll: false
            })
        }
    };
    onSelectionChange = (event) => {
        const value = event.value;
        let selectedAll = (value.length === this.state.categoryAssignInfo.length)
        this.setState({
            selectedCategoryAssignInfo: event.value,
            selectAll: selectedAll

        })
    }

    getSMSString = (str, txtEnteredMsgs) => {

        // var str = 'Dear Parent, This is to inform you that your ward {#var#}., is absent for {#var#}. out of {#var#}. conducted on {#var#}.. {#var#}.';


        let textMsgs = {
            // "50": "1st",
            // "74": "2nd",
            // "90": "3rd",
            // "112": "4th",
            // "122": "5th"
        }

        // for (var i = 0; i < str.length; i++) {
        //     if (str[i] === "{#var#}") {
        //         textMsgs[i] = ''
        //     }
        // }

        var regex = /{#var#}/gi, result, indices = [];
        while ((result = regex.exec(str))) {
            //  indices.push(result.index);
            textMsgs[result.index] = ''
        }


        textMsgs = { ...textMsgs, ...txtEnteredMsgs }


        Object.keys(textMsgs).forEach(a => {
            let result = str.lastIndexOf('{#var#}')
            str = str.slice(0, result) + str.slice(result + 7);
            str = this.addStr(str, result, textMsgs[`${result}`])
        });

        // console.log(str)

        return str;

    }


    getParamsForWhatsApp = (str, txtEnteredMsgs) => {

        // var str = 'Dear Parent, This is to inform you that your ward {#var#}., is absent for {#var#}. out of {#var#}. conducted on {#var#}.. {#var#}.';


        let textMsgs = {
            // "50": "1st",
            // "74": "2nd",
            // "90": "3rd",
            // "112": "4th",
            // "122": "5th"
        }

        // for (var i = 0; i < str.length; i++) {
        //     if (str[i] === "{#var#}") {
        //         textMsgs[i] = ''
        //     }
        // }

        var regex = /{#var#}/gi, result, indices = [];
        while ((result = regex.exec(str))) {
            //  indices.push(result.index);
            textMsgs[result.index] = ''
        }


        textMsgs = { ...textMsgs, ...txtEnteredMsgs }

        let params = [];
        Object.keys(textMsgs).forEach(a => {
            params.push(textMsgs[a]);
        });

        // console.log(str)

        return params;

    }
    addStr(str, index, stringToAdd) {
        return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
    }

    onSubmitNotification = () => {

        this.setState({ isLoading: true })
        const { smsTemplateContent, whatsAppTemplateBody, textMsgs, notification } = this.state;

        const academicYear = localStorage.getItem('userAcademicYear')
        let payload = this.state.notification;
        if (notification.mode == NOTIFICATION_MODES.SMS) {
            if (smsTemplateContent && smsTemplateContent.length) {
                payload.message = this.getSMSString(smsTemplateContent, textMsgs);
            }
        }

        if (notification.mode == NOTIFICATION_MODES.WHATS_APP) {
            if (whatsAppTemplateBody && whatsAppTemplateBody.length) {
                payload.params = this.getParamsForWhatsApp(whatsAppTemplateBody, textMsgs);
            }
        }
        payload.academicYear = academicYear

        const formStatus = isFormValid(formFields, this.formFields.formValidations, trimObj(payload));
        if (!formStatus.formValidations.isFormValid) {
            this.setState({ formValidations: formStatus.formValidations, isLoading: false });

        } else {
            if (!this.state.notification?._id) {
                let url = `${baseUrlAdmin}/notification-manager/create`;
                this.service.post(url, payload, true).then(data => {
                    if (data?.status) {
                        this.setState({
                            isLoading: false,
                            editDialog: false, isDialogOpenForCreateNotification: false, notification: {}
                        })
                        this.toast?.show({ severity: 'success', summary: 'Success', detail: data?.res?.message, life: 3000 });
                        this.getNotifications()
                    } else {
                        this.setState({ isLoading: false })
                        this.toast?.show({ severity: 'error', summary: 'Error', detail: data?.errMessage, life: 3000 });
                    }
                })
                    .catch(err => {
                        this.setState({ isLoading: false })
                        this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while Creating the fee type', life: 3000 });
                    });
            }
            else if (this.state?.notification?._id) {
                this.setState({ isLoading: true })
                payload._id = this.state?.notification?._id;
                let url = `${baseUrlAdmin}/notification-manager/update`;
                this.service.post(url, payload, true).then(data => {
                    if (data?.status) {
                        this.setState({
                            isLoading: false,
                            notification: {},
                            editDialog: false,
                            isDialogOpenForCreateNotification: false
                        })
                        this.getNotifications()
                        this.toast?.show({ severity: 'success', summary: 'Success', detail: data?.res?.message, life: 3000 });
                    } else {
                        this.setState({ isLoading: false })
                        this.toast?.show({ severity: 'error', summary: 'Error', detail: data?.errMessage, life: 3000 });

                    }

                }).catch(err => {
                    this.setState({ isLoading: false })
                    this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while Updating the fee type', life: 3000 });
                });


            }

        }
    }

    getFeeCategoryOptions = () => {
        let academicYear = localStorage.getItem('userAcademicYear')
        let payload = {}
        payload.academicYear = academicYear
        let url = `${baseUrlAdmin}/fee-category/filtered`;
        this.service.post(url, payload, true).then((data) => {
            const options = data?.res?.data?.map((each) => {
                return {
                    label: each.categoryName,
                    value: each._id
                }
            })

            if (data?.status && data?.res?.data) {

                this.setState({ feeCategoriesOptions: options })
            } else {
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while getting the fee category options', life: 3000 });

            }

        }).catch(error => {
            console.error('Error fetching fee categories:', error);
            this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch fee categories', life: 3000 });
        })
    }
    getAdmissionCategoryOptions = () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`
        this.service.get(url, {}, true).then((data) => {
            const options = data?.res?.data?.map((each) => {
                return {
                    label: each?.categoryName,
                    value: each?._id
                }
            })

            if (data?.status && data?.res?.data) {

                this.setState({ admissionCategories: data?.res?.data })
            } else {
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while getting the Admission category options', life: 3000 });

            }

        }).catch(error => {
            console.error('Error fetching admission categories:', error);
            this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch admission categories', life: 3000 });
        })
    }

    onPage = (event) => {
        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getNotifications);

    }

    onEditMultiDD = (selectedValue, key) => {
        if (this.state.editDialog) {
            let isCondition = this.state.backupEditData[key]?.every(item => selectedValue.includes(item));
            if (!isCondition && this.state.backupEditData.assignedStudents > 0) {
                this.toast?.show({ severity: 'warn', summary: `can't remove already assigned value`, life: 3000 });
                return false
            }
        }

        return true
    }

    nothing = () => {
        console.log('fsdfsfsdf')
    }
    handleInputChange = (index, field, value) => {
        const stops = [...this.state.stops];
        if (field === 'pickUpTime' || field === 'dropTime') {
            if (value instanceof Date && !isNaN(value)) {
                const hours = value.getHours().toString().padStart(2, '0');
                const minutes = value.getMinutes().toString().padStart(2, '0');
                value = `${hours}:${minutes}`;
            }
        }
        stops[index][field] = value;
        this.setState({ stops });
    };
    updateFields = (requiredFields, notRequiredFields) => {
        let { notification } = this.state;

        formFields = formFields.map(field => {
            if (requiredFields.includes(field.FieldName)) {

                field.Required = true;
            }

            if (notRequiredFields.includes(field.FieldName)) {
                notification[field.FieldName] = '';

                field.Required = undefined;
            }

            return field;
        });
        this.formFields = getFormFields(formFields, this.state.org);

        this.setState({
            notification,
            formValidations: this.formFields.formValidations,
            textMsgs: {},
            smsTemplateContent: "",
            whatsAppTemplateBody: ""
        })
    }
    onMessageTemplateChange = (fieldName, data) => {

        let smsTemplateContent = this.state.smsTemplates.find(a => a._id == data).content

        let notification = {
            ...this.state.notification,
            [fieldName]: data,

        }

        let formValidations = isFieldValid(formFields.find(fm => fm.FieldName == fieldName), this.state.formValidations, notification);


        this.setState((prevState) => {
            return {
                notification,
                formValidations,
                smsTemplateContent
            }
        });
    }
    onTxtMsgFieldChange = (position, value) => {
        this.setState((prevState) => {
            return {
                textMsgs: {
                    ...prevState.textMsgs,
                    [position]: value
                }
            }
        });
    }
    formatWhatsAppTemplateTxt = (str) => {
        let result;
        let i = 100;
        do {
            result = str.lastIndexOf(`{{${i}}}`);
            if (result >= 0) {
                str = str.slice(0, result) + '{#var#}' + str.slice(result + 5);
            }
            i--;
        } while (i > 0);
        return str;
    }
    onWhatsAppTemplateChange = (fieldName, data) => {

        let template = this.state.whatsAppTemplates.find(a => a._id == data);
        let whatsAppTemplateBody = template.body

        whatsAppTemplateBody = this.formatWhatsAppTemplateTxt(whatsAppTemplateBody)

        let notification = {
            ...this.state.notification,
            [fieldName]: data,
            whatsAppTemplateName: template.name

        }

        let formValidations = isFieldValid(formFields.find(fm => fm.FieldName == fieldName), this.state.formValidations, notification);


        this.setState({
            notification,
            formValidations,
            whatsAppTemplateBody
        });
    }
    onSubmitClick = () => {

        const { notification, smsTemplateContent, whatsAppTemplateBody, textMsgs } = this.state;

        let _notification = notification;

        if (_notification.mode == NOTIFICATION_MODES.SMS) {
            if (smsTemplateContent && smsTemplateContent.length) {
                _notification.message = this.getSMSString(smsTemplateContent, textMsgs);
            }
        }

        if (_notification.mode == NOTIFICATION_MODES.WHATS_APP) {
            if (whatsAppTemplateBody && whatsAppTemplateBody.length) {
                _notification.params = this.getParamsForWhatsApp(whatsAppTemplateBody, textMsgs);
            }
        }

        const formStatus = isFormValid(formFields, this.formFields.formValidations, trimObj(_notification));

        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                isSubmitClick: true,
                formValidations: formStatus.formValidations,
            });
        } else {
            if (_notification.mode == NOTIFICATION_MODES.WHATS_APP) {
                if (_notification.params && _notification.params.length) {
                    let isValid = true;
                    _notification.params.forEach(param => {
                        if (!(param || param.length)) {
                            isValid = false
                        }
                    });

                    if (!isValid) {
                        return this.toast.show({ severity: 'error', summary: 'Invalid', detail: 'Please complete the message', life: 3000 });
                    }

                }
            }
        }


    }



    deleteNotification = () => {



        if (this.state?.notification != null) {

            this.setState({
                isLoading: true
            });
            const url = `${baseUrlAdmin}/notification-manager/${this.state?.notification?._id}`;
            this.service.delete(url, {}, true).then((data) => {

                if (data && data.res && data.res.status) {
                    this.setState({
                        isLoading: false,
                        isRejectDialogOpen: false
                    });
                    this.getNotifications()
                    this.toast?.show({ severity: 'success', summary: 'Success', detail: data?.res?.message, life: 3000 });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: 'Unkown error', life: 3000 });
                }

            }).catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            });
        }




    }

    assignStudents = async (users, assignType, alertRecipients = null) => {
        let { editNofication } = this.state;

        if (this.state?.dropdownsData?.branchId && editNofication && users.length > 0) {
            // Calculate total users count based on assignment type
            let totalUsersCount = 0;

            if (assignType === "users") {
                // Direct user count
                totalUsersCount = users.length;
            } else if (assignType === "sections") {
                // Sum up student from selected sections
                totalUsersCount = this.state.selectedCategoryAssignInfo.reduce((sum, section) => {
                    return sum + (section.totalStudents || 0);
                }, 0);
            } else if (assignType === "grades") {
                // Sum up student from selected grades/classes
                totalUsersCount = this.state.selectedCategoryAssignInfo.reduce((sum, grade) => {
                    return sum + (grade.totalStudents || 0);
                }, 0);
            }

            const thirdPartyResponse = await this.service.get(`${baseUrlAdmin}/organization/thirdPartySettings`, true);

            // Check if third party response is valid
            if (!thirdPartyResponse?.status || !thirdPartyResponse?.res?.data) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Unable to fetch pricing information. Please try again.',
                    life: 3000
                });
                return;
            }

            const { totalBalance } = thirdPartyResponse.res.data;
            // Convert totalBalance from rupees to paise for comparison
            const totalBalanceInPaise = totalBalance * 100;
            const mode = editNofication.mode;
            let requiredBalanceInPaise = 0;

            // Calculate required balance based on notification mode (prices are in paise)
            if (mode === 'sms') {
                const smsPrice = thirdPartyResponse.res.data.sms?.price || 0; // in paise
                const noOfCredits = editNofication.noOfCredits || 1;
                requiredBalanceInPaise = totalUsersCount * noOfCredits * smsPrice;
            } else if (mode === 'whatsapp') {
                const whatsappPrice = thirdPartyResponse.res.data.whatsapp?.price || 0; // in paise
                requiredBalanceInPaise = totalUsersCount * whatsappPrice;
            } else if (mode === 'email') {
                const emailPrice = thirdPartyResponse.res.data.email?.price || 0; // in paise
                requiredBalanceInPaise = totalUsersCount * emailPrice;
            }

            // Check if balance is sufficient (both in paise)
            if (requiredBalanceInPaise > totalBalanceInPaise) {
                // Convert back to rupees for display
                const requiredBalanceInRupees = (requiredBalanceInPaise / 100).toFixed(2);
                const availableBalanceInRupees = totalBalance.toFixed(2);

                this.toast.show({
                    severity: 'error',
                    summary: 'Insufficient Balance',
                    detail: `Required balance: ₹${requiredBalanceInRupees}, Available balance: ₹${availableBalanceInRupees}. Please recharge your account.`,
                    life: 5000
                });
                return;
            }

            let payload = {
                ...editNofication,
                assignTo: assignType,
                assignIds: users,
                usersCount: users?.length,
                triggeredUser: localStorage.getItem('username'),
            };

            // Add alert recipients if notification mode is alert
            if (editNofication.mode === NOTIFICATION_MODES.ALERT && alertRecipients) {
                payload.alertRecipients = alertRecipients;
            }

            this.setState({
                isLoading: true
            });
            const url = `${baseUrlAdmin}/notification-manager/send`;
            this.service.post(url, payload, true).then((data) => {

                if (data && data.res && data.res.status) {
                    console.log(data, "datadatadatadata")
                    this.setState({
                        isLoading: false,
                        feeStructureAssignDialog: false,
                        dropdownsData: {},
                        selectedCategoryAssignInfo: [],
                        categoryAssignInfo: [],
                        selectAll: false,
                        selectedAlertRecipients: []
                    });
                    this.toast?.show({ severity: 'success', summary: 'Success', detail: data?.res?.message, life: 3000 });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: data?.message, life: 3000 });
                }

            }).catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            });
        }




    }

    openNotificationHistory = (notification) => {
        this.setState({
            notificationHistoryDialog: true,
            selectedNotification: notification
        });
    }

    handleAlertRecipientSelection = () => {
        const { selectedCategoryAssignInfo, selectedAlertRecipients } = this.state;

        // For alert notifications, check if recipients are selected
        if (this.state.editNofication?.mode === NOTIFICATION_MODES.ALERT && selectedAlertRecipients.length === 0) {
            this.toast?.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please select at least one recipient type (Students or Parents).',
                life: 3000
            });
            return;
        }

        if (selectedCategoryAssignInfo.length > 0) {
            // Proceed with sending alerts to selected recipients
            if (selectedCategoryAssignInfo[0].user_id != undefined) {
                // multiple student
                this.assignStudents(selectedCategoryAssignInfo.map((i) => i.user_id), "users", selectedAlertRecipients);
            } else if (selectedCategoryAssignInfo[0].sectionId != undefined) {
                // multiple sections
                this.assignStudents(selectedCategoryAssignInfo.map((i) => i.sectionId), "sections", selectedAlertRecipients);
            } else {
                // multiple classes/grades
                this.assignStudents(selectedCategoryAssignInfo.map((i) => i.classId), "grades", selectedAlertRecipients);
            }
        }
    }

    _onProgress = (progress) => {
        // Handle upload progress if needed
        console.log('Upload progress:', progress);
    }

    _onFilsUploadError = (error) => {
        console.error('File upload error:', error);
        this.toast?.show({
            severity: 'error',
            summary: 'Upload Error',
            detail: 'Failed to upload file. Please try again.',
            life: 3000
        });
    }

    // Add a helper function to check if file is an image
    isImageFile = (fileName) => {
        if (!fileName) return false;
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        const lowerFileName = fileName.toLowerCase();
        return imageExtensions.some(ext => lowerFileName.endsWith(ext));
    }

    render() {
        const { currentStep, notification, formValidations, textMsgs } = this.state;
        return (
            <div>
                <div className='admin-management'>
                    <div className="grid mb-6 mt-2">
                        <div className='col-12 flex justify-content-end align-items-center'>
                            <Button onClick={this.handleOpenCreate} className='addButtonn'>
                                <AddIcon2 />
                                <p className='' >Add New Notification</p>
                            </Button>
                        </div>
                    </div>

                    <div className="ma-m30">
                        <DataTable ref={(el) => this.dt = el}
                            value={this.state.notificationsData}
                            dataKey="id"
                            paginator
                            lazy
                            className="dataTableValuesText"
                            onSort={this.onSort}
                            onPage={this.onPage}
                            onFilter={this.onFilter}
                            first={this.state.lazyParams.first}
                            last={this.state.totalRecords}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Notifications"
                            globalFilter={this.state.globalFilter}
                            responsiveLayout="scroll"

                        >

                            <Column header="S.No." style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' body={(rowData, index) => {
                                return (
                                    <>
                                        <p>{index.rowIndex + 1}</p>
                                    </>
                                )
                            }} />
                            <Column field="name" header="Name of the Event" style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' />


                            <Column header="Notification Type" field="type" style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' />


                            <Column header="Notification History" style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center'
                                body={(rowData) => (
                                    <div>
                                        <Button
                                            className="p-button-link"
                                            label={`${rowData.usersCount || 0} Recipients`}
                                            onClick={() => this.openNotificationHistory(rowData)}
                                            icon="pi pi-history"
                                        />
                                    </div>
                                )} />
                            <Column field="mode" header="Notification Mode" style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' />

                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' header="Share" body={(rowData, { rowIndex }) => {
                                // Remove all scheduling related logic, keep only simple send now button
                                return (
                                    <div className="flex justify-content-center">
                                        <Button
                                            label="Send Now"
                                            icon="pi pi-send"
                                            onClick={() => this.handleShare(rowData)}
                                            className="p-button-outlined"
                                        />
                                    </div>
                                );
                            }} ></Column>
                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' header="Edit" body={(rowData, { rowIndex }) => {
                                return (<>
                                    <div className="flex justify-content-center">

                                        <span data-pr-tooltip="Edit Notification" data-pr-position="" className={`ma-ml10 awl${rowIndex}`}
                                            onClick={() => { this.onEdit(rowData) }}
                                        >
                                            <ClassetEditIcon width={32} height={32} color={'#000000'} />


                                        </span>

                                    </div>
                                </>
                                );
                            }} ></Column>

                            <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' header="Delete" body={(rowData, { rowIndex }) => {
                                return (<>
                                    <div className="flex  justify-content-center">

                                        <span data-pr-tooltip="Delete Notification" data-pr-position="" className={`ma-ml10 awl${rowIndex}`}

                                            onClick={() => this.setState({ isRejectDialogOpen: true, notification: rowData })}
                                        >
                                            <DeleteIconClasset width={32} height={32} color={'#000000'} />
                                        </span>

                                    </div>
                                </>
                                );
                            }} ></Column>

                        </DataTable>

                        <Toast ref={(el) => this.toast = el} position="bottom-right" />

                        {this.state.isLoading && <LoadingComponent />}
                    </div>
                </div >
                <Dialog
                    visible={this.state.isDialogOpenForCreateNotification}
                    draggable={false}
                    closeOnEscape={false}
                    className='ma-alert-box w-8'
                    style={{ width: "500px", height: "700px" }}
                    dismissableMask={false}
                    closable={true}
                    header={() => {
                        return (<div className='mt-2'>
                            <h4 className="formHeadingInter">Create Notification</h4>
                        </div>)
                    }}
                    footer={() => (
                        <div className='flex justify-content-center mb-4'>
                            <Button className='formSubmitButton px-6' style={{ borderRadius: '10px', marginRight: 10 }} onClick={this.onSubmitNotification} >
                                <p className='formSubmitButtonText'> {this.state.editDialog ? 'Update' : 'Create'}</p>
                            </Button>
                            <Button className='formCancelButton px-6' style={{ borderRadius: '10px' }} onClick={() => this.setState({ dateRange: null, isDialogOpenForCreateNotification: false, editDialog: false, notification: {} })} >
                                <p className='formCancelButtonText'>Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ dateRange: null, isDialogOpenForCreateNotification: false, editDialog: false, notification: {} })}
                >
                    <div className='flex flex-column justify-content-center mx-6 align-items-center' >
                        <div className='grid  justify-content-center'>
                            <div className={notification.mode ? 'col-6 justify-content-center' : 'col-6 '}>
                                <div>
                                    <ClassetInputText
                                        required={true}
                                        label={'Notification Title'}
                                        icon={<MailIcon />}
                                        width={'470px'}
                                        placeholder={'Title'}
                                        value={notification.name}
                                        onChange={(e) => { onTextChange(e.target.value, 'name', this, formFields, notification, formValidations, 'notification', 'formValidations') }}
                                        title="Name"
                                    />
                                    {formValidations && !formValidations.fields['name'].isValid && <p className="p-error font-semibold">{formValidations.fields['name'].errorMsg}</p>}
                                </div>
                                <div className="mt-4">
                                    <ClassetDropdown
                                        required={true}
                                        width={'470px'}
                                        label={'Notification Type'}
                                        icon={<AcademicSessionCalIcon />}
                                        placeholder={'Select Notification Type'}
                                        options={NotificationTypes}
                                        value={notification.type}
                                        onChange={(e) => {
                                            onDropDownChange(e.value, 'type', this, formFields, notification, formValidations, 'notification', 'formValidations')
                                        }}
                                    />

                                    {formValidations && !formValidations.fields['type'].isValid && <p className="p-error font-semibold">{formValidations.fields['type'].errorMsg}</p>}

                                </div>

                                <div className="grid ma-w100p mt-5" >
                                    <div className="col-12 p-md-3 ">
                                        <label className={`ma-label-s2 font-serif font-semibold text-900 text-lg `}>{'Notification Mode'}
                                            {<span className="ma-required">*</span>}
                                        </label>
                                        <div >
                                            <div className='col-4 flex gap-3 -ml-3'>
                                                <div className="flex align-items-center" style={{ padding: '2px' }}>
                                                    <RadioButton className="radio-inline mr-2" value={NOTIFICATION_MODES.ALERT} inputid="coyes" name="mode"
                                                        onChange={(e) => {
                                                            onChoiceChange(e.value, 'mode', this, formFields, notification, formValidations, 'notification', 'formValidations', () => {
                                                                this.updateFields(['title', 'description'], ['whatsAppTemplateId', 'message', 'subject', 'body', 'smsTemplateId'])

                                                            });
                                                        }}
                                                        checked={notification.mode === NOTIFICATION_MODES.ALERT}
                                                        disabled={this.state.editDialog}
                                                    />
                                                    <label className={`ma-label-s1 ${this.state.editDialog ? 'text-500' : ''}`} htmlFor={NOTIFICATION_MODES.ALERT}>Alert</label>
                                                </div>
                                                <div className="flex align-items-center" style={{ padding: '2px' }}>
                                                    <RadioButton className="radio-inline ma-ml10 mr-2" value={NOTIFICATION_MODES.SMS} inputid="cono" name="mode"
                                                        onChange={(e) => {
                                                            onChoiceChange(e.value, 'mode', this, formFields, notification, formValidations, 'notification', 'formValidations', () => {
                                                                this.updateFields(['message', 'smsTemplateId'], ['whatsAppTemplateId', 'title', 'description', 'subject', 'body'])
                                                            })

                                                        }}
                                                        checked={notification.mode === NOTIFICATION_MODES.SMS}
                                                        disabled={this.state.editDialog}
                                                    />
                                                    <label className={`ma-label-s1 ${this.state.editDialog ? 'text-500' : ''}`} htmlFor={NOTIFICATION_MODES.SMS}>SMS</label>
                                                </div>
                                                <div className="flex align-items-center" style={{ padding: '2px' }}>
                                                    <RadioButton className="radio-inline ma-ml10 mr-2" value={NOTIFICATION_MODES.EMAIL} inputid="cono" name="mode"
                                                        onChange={(e) => {
                                                            onChoiceChange(e.value, 'mode', this, formFields, notification, formValidations, 'notification', 'formValidations', () => {
                                                                this.updateFields(['subject', 'body',], ['whatsAppTemplateId', 'title', 'description', 'message', 'smsTemplateId'])
                                                            })

                                                        }}
                                                        checked={notification.mode === NOTIFICATION_MODES.EMAIL}
                                                        disabled={this.state.editDialog}
                                                    />
                                                    <label className={`ma-label-s1 ${this.state.editDialog ? 'text-500' : ''}`} htmlFor={NOTIFICATION_MODES.EMAIL}>Email</label>
                                                </div>
                                                <div className="flex align-items-center" style={{ padding: '2px' }}>
                                                    <RadioButton className="radio-inline ma-ml10 mr-2" value={NOTIFICATION_MODES.WHATS_APP} inputid="cono" name="mode"
                                                        onChange={(e) => {
                                                            onChoiceChange(e.value, 'mode', this, formFields, notification, formValidations, 'notification', 'formValidations', () => {

                                                                this.updateFields(['whatsAppTemplateId'], ['body', 'title', 'description', 'message', 'smsTemplateId', 'subject'])
                                                            });
                                                        }}

                                                        checked={notification.mode === NOTIFICATION_MODES.WHATS_APP}
                                                        disabled={this.state.editDialog}
                                                    />
                                                    <label className={`ma-label-s1 ${this.state.editDialog ? 'text-500' : ''}`} htmlFor={NOTIFICATION_MODES.WHATS_APP}>WhatsApp</label>
                                                </div>
                                            </div>
                                            {this.state.editDialog && (
                                                <div className="mt-1">
                                                    <small className="text-blue-500 font-italic">
                                                        Note: Notification mode cannot be changed after creation
                                                    </small>
                                                </div>
                                            )}
                                        </div>
                                        {formValidations && !formValidations.fields['mode'].isValid && <p className="p-error">{formValidations.fields['mode'].errorMsg}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                {notification.mode == NOTIFICATION_MODES.ALERT && <>
                                    <div className=''>
                                        <div className=''>
                                            <div className=''>
                                                <ClassetInputText value={notification.title} label={'Title'}
                                                    onChange={(e) => { onTextChange(e.target.value, 'title', this, formFields, notification, formValidations, 'notification', 'formValidations') }}
                                                    className='p-inputtext-style1 w-full' />
                                                {formValidations && !formValidations.fields['title'].isValid && <p className="p-error">{formValidations.fields['title'].errorMsg}</p>}
                                            </div>
                                            <div className='mt-3'>
                                                <ClassetTextArea
                                                    rows={8}
                                                    label={'Description'}
                                                    height={'209px'}
                                                    value={notification.description}
                                                    onChange={(e) => { onTextChange(e.target.value, 'description', this, formFields, notification, formValidations, 'notification', 'formValidations') }}
                                                    className='p-inputtext-style1 w-full' />
                                                {formValidations && !formValidations.fields['description'].isValid && <p className="p-error">{formValidations.fields['description'].errorMsg}</p>}
                                            </div>

                                        </div>
                                    </div>
                                </>}

                                {notification.mode == NOTIFICATION_MODES.SMS && <>
                                    {
                                        <>
                                            <div className=' '>
                                                <div className=''>
                                                    <div className=''>
                                                        <ClassetDropdown value={notification.smsTemplateId}
                                                            className='w-full'
                                                            required={true}
                                                            label={'Approved SMS ID'}
                                                            options={this.state.smsTemplates}
                                                            onChange={(e) => {
                                                                this.onMessageTemplateChange('smsTemplateId', e.value)
                                                            }}
                                                            optionLabel='name'
                                                            optionValue='_id'
                                                            placeholder="Select Template" />
                                                        {formValidations && !formValidations.fields['smsTemplateId'].isValid && <p className="p-error">{formValidations.fields['smsTemplateId'].errorMsg}</p>}
                                                    </div>


                                                </div>
                                            </div>
                                            {
                                                notification.smsTemplateId &&
                                                <div className='flex flex-row -m-3 mt-1'>
                                                    <div className='col-12 p-md-6 p-lg-6'>
                                                        <div className=' '>
                                                            <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Description<span className='ma-required'>*</span></p>
                                                            <div className='sms-template-txt card'>
                                                                {reactStringReplace(this.state.smsTemplateContent, '{#var#}', (match, i, offset) => (
                                                                    <ClassetInputText value={textMsgs[offset] ? textMsgs[offset] : ''} onChange={(e) => { this.onTxtMsgFieldChange(offset, e.target.value) }} />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {/* {formValidations && !formValidations.fields['message'].isValid && <p className="p-error">{formValidations.fields['message'].errorMsg}</p>} */}
                                        </>}
                                </>}

                                {notification.mode == NOTIFICATION_MODES.EMAIL && <>
                                    {
                                        <>
                                            <div className=''>
                                                <div className=''>
                                                    <ClassetInputText value={notification.subject}
                                                        required={true}
                                                        label={'Subject'}
                                                        onChange={(e) => { onTextChange(e.target.value, 'subject', this, formFields, notification, formValidations, 'notification', 'formValidations') }}
                                                        className='p-inputtext-style1 w-full' />
                                                    {formValidations && !formValidations.fields['subject'].isValid && <p className="p-error">{formValidations.fields['subject'].errorMsg}</p>}
                                                    <div className=''>
                                                        <ClassetTextArea
                                                            rows={100}
                                                            required={true}
                                                            label={'Message Body'}
                                                            height={'209px'}
                                                            value={notification.body}
                                                            onChange={(e) => { onTextChange(e.target.value, 'body', this, formFields, notification, formValidations, 'notification', 'formValidations') }}
                                                            className='p-inputtext-style1 w-full' />
                                                        {formValidations && !formValidations.fields['body'].isValid && <p className="p-error">{formValidations.fields['body'].errorMsg}</p>}
                                                    </div>
                                                    <div className='mt-3'>
                                                        <FileUploadLambda id={'notifatt_email'}
                                                            multiple={false}
                                                            onProgress={this._onProgress}
                                                            onSucess={(fileName, data) => this._onAttachSuccess('attachment')(fileName, data)}
                                                            maxFileSize={5120000}
                                                            onError={this._onFilsUploadError}
                                                            accept={'images'}  // Change this to just 'images' to fix the file type issue
                                                            title={'Email Attachments'}
                                                            dirName=''
                                                            afterFilesUploaded={this._afterFilesUploaded}
                                                        >
                                                            <label className='ma-label-s2 font-serif font-semibold text-900 text-lg' htmlFor={'notifatt_email'}>
                                                                Attachment <i className='pi pi-file' />
                                                            </label>
                                                        </FileUploadLambda>

                                                        {/* Fix: Use consistent logic for both Alert and Email sections */}
                                                        {notification['attachment'] && (
                                                            <div className="mt-2 p-2 border-1 surface-border border-round">
                                                                <div className="flex align-items-center justify-content-between">
                                                                    <span className="text-sm">
                                                                        {notification['attachmentFileName'] || 'Attached file'}
                                                                    </span>
                                                                    <Button
                                                                        icon="pi pi-times"
                                                                        className="p-button-text p-button-danger p-button-sm"
                                                                        onClick={() => this.removeAttach('attachment')}
                                                                        tooltip="Remove attachment"
                                                                    />
                                                                </div>
                                                                {/* Use the same logic as Alert section */}
                                                                {this.isImageFile(notification['attachmentFileName']) && (
                                                                    <img
                                                                        src={`https://${imagesBucket}.s3.${awsRegion}.amazonaws.com/${notification['attachment']}`}
                                                                        alt="Attachment preview"
                                                                        className='question-img mt-2'
                                                                        style={{ maxWidth: '200px', maxHeight: '150px' }}
                                                                    />
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </>}

                                {notification.mode == NOTIFICATION_MODES.WHATS_APP && <>
                                    {
                                        <>
                                            <div className=''>
                                                <div className=''>
                                                    <div className=''>
                                                        <ClassetDropdown value={notification.whatsAppTemplateId}
                                                            className='w-full'
                                                            label={'Message Template'}
                                                            options={this.state.whatsAppTemplates}
                                                            onChange={(e) => {
                                                                this.onWhatsAppTemplateChange('whatsAppTemplateId', e.value)
                                                            }}
                                                            optionLabel='name'
                                                            optionValue='_id'
                                                            placeholder="Select Template" />
                                                        {formValidations && !formValidations.fields['whatsAppTemplateId'].isValid && <p className="p-error">{formValidations.fields['whatsAppTemplateId'].errorMsg}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                notification.whatsAppTemplateId && <div className='flex flex-row -m-3 mt-2'>
                                                    <div className='col-12 p-md-6 p-lg-6'>
                                                        <div className=''>
                                                            <p className='`ma-label-s2 font-serif font-semibold text-900 text-lg'>Message<span className='ma-required'></span></p>
                                                            <div className='sms-template-txt card'>
                                                                {reactStringReplace(this.state.whatsAppTemplateBody, '{#var#}', (match, i, offset) => (
                                                                    <ClassetInputText value={textMsgs[offset] ? textMsgs[offset] : ''} onChange={(e) => { this.onTxtMsgFieldChange(offset, e.target.value) }} className='p-inputtext-style1' />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {formValidations && !formValidations.fields['message'].isValid && <p className="p-error">{formValidations.fields['message'].errorMsg}</p>}
                                        </>}
                                </>}

                            </div>
                        </div>

                    </div>
                </Dialog >

                <Dialog
                    isOpen={this.state.feeStructureAssignDialog}
                    visible={this.state.feeStructureAssignDialog}
                    style={{ width: '80vw', height: '80vh', }}
                    draggable={false}
                    maximizable        // Enable maximize button
                    modal
                    onHide={this.onHideAssignDialog}
                    closable={true}
                    header={() => {
                        return (
                            <div className='mt-4'>
                                <h3 className="text-center formhead">Notification Assign</h3>
                            </div>
                        )
                    }}
                >
                    <div className="p-5">
                        <div className=''>
                            <div className="grid mb-2 ">
                                <BranchToSectionDD setValues={this.setDropdownValues} />
                            </div>
                        </div>

                        {/* Alert Recipients Selection - Show only for alert notifications */}
                        {this.state.editNofication?.mode === NOTIFICATION_MODES.ALERT && (
                            <div className="mb-4 p-3 border-1 surface-border border-round">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg mb-3 block">
                                    Send alert notification to:
                                    <span className="ma-required">*</span>
                                </label>
                                <div className="flex gap-4">
                                    <div className="flex align-items-center">
                                        <input
                                            type="checkbox"
                                            id="student"
                                            className="mr-2"
                                            checked={this.state.selectedAlertRecipients.includes('student')}
                                            onChange={(e) => {
                                                const { selectedAlertRecipients } = this.state;
                                                if (e.target.checked) {
                                                    this.setState({
                                                        selectedAlertRecipients: [...selectedAlertRecipients, 'student']
                                                    });
                                                } else {
                                                    this.setState({
                                                        selectedAlertRecipients: selectedAlertRecipients.filter(r => r !== 'student')
                                                    });
                                                }
                                            }}
                                        />
                                        <label htmlFor="student" className="ma-label-s1">Students</label>
                                    </div>
                                    <div className="flex align-items-center">
                                        <input
                                            type="checkbox"
                                            id="parent"
                                            className="mr-2"
                                            checked={this.state.selectedAlertRecipients.includes('parent')}
                                            onChange={(e) => {
                                                const { selectedAlertRecipients } = this.state;
                                                if (e.target.checked) {
                                                    this.setState({
                                                        selectedAlertRecipients: [...selectedAlertRecipients, 'parent']
                                                    });
                                                } else {
                                                    this.setState({
                                                        selectedAlertRecipients: selectedAlertRecipients.filter(r => r !== 'parent')
                                                    });
                                                }
                                            }}
                                        />
                                        <label htmlFor="parent" className="ma-label-s1">Parents</label>
                                    </div>
                                </div>
                                {this.state.selectedAlertRecipients.length === 0 && (
                                    <small className="text-red-500 mt-2 block">
                                        Please select at least one recipient type.
                                    </small>
                                )}
                            </div>
                        )}

                        <DataTable ref={(el) => this.dt = el}
                            value={this.state.categoryAssignInfo}
                            dataKey={this.state?.dropdownsData?.sectionId ? 'user_id' : this.state?.dropdownsData?.classId ? 'sectionId' : 'classId'}
                            paginator
                            rows={10}
                            // showGridlines
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            // globalFilter={this.state.globalFilter}
                            responsiveLayout="scroll"
                            // header={header}
                            sortable
                            selection={this.state?.selectedCategoryAssignInfo}
                            onSelectionChange={this.onSelectionChange}
                            selectAll={this.state.selectAll}
                            onSelectAllChange={this.onSelectAllChange}
                            selectionMode="checkbox"

                        >

                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                            <Column field="branchName" header="Brach Name" className="datatable-cel" sortable />
                            <Column field="boardName" header="Board Name" className="datatable-cel" sortable />
                            <Column field="className" header="Grade Name" className="datatable-cel" sortable />
                            {this.state?.dropdownsData?.classId ? <Column field="sectionName" header="Section Name" className="datatable-cel" sortable /> : <></>}
                            {this.state?.dropdownsData?.sectionId ? <></> : <Column field="totalStudents" header="Total Students" className="datatable-cel" sortable />}

                            {this.state?.dropdownsData?.sectionId ? <Column field="username" header="Students" className="datatable-cel" body={(rowData) => {
                                return (

                                    <p>{(rowData?.username)?.slice(3)}</p>
                                )
                            }} /> : <></>}
                            {this.state?.dropdownsData?.sectionId ? <Column field="studentName" header="Student Name" className="datatable-cel" body={(rowData) => {
                                return (

                                    <p>{(rowData?.studentName)}</p>
                                )
                            }} /> : <></>}

                        </DataTable>
                        <div className='flex justify-content-center mb-4 mt-4'>
                            <Button
                                className='submitButtonn w-2'
                                onClick={() => {
                                    if (Array.isArray(this.state?.selectedCategoryAssignInfo)) {
                                        // Check if notification mode is alert
                                        if (this.state.editNofication?.mode === NOTIFICATION_MODES.ALERT) {
                                            // Use the integrated alert recipient selection
                                            this.handleAlertRecipientSelection();
                                        } else {
                                            // Proceed with normal flow for non-alert notifications
                                            if (this.state.selectedCategoryAssignInfo[0].user_id != undefined) {
                                                // multiple student/users
                                                this.assignStudents(this.state.selectedCategoryAssignInfo.map((i) => i.user_id), "users");
                                            } else if (this.state.selectedCategoryAssignInfo[0].sectionId != undefined) {
                                                // multiple sections
                                                this.assignStudents(this.state.selectedCategoryAssignInfo.map((i) => i.sectionId), "sections");
                                            } else {
                                                // multiple classes/grades
                                                this.assignStudents(this.state.selectedCategoryAssignInfo.map((i) => i.classId), "grades");
                                            }
                                        }
                                    }
                                }}
                            >
                                <p className='submitButtonnText'>
                                    Send
                                </p>
                            </Button>
                            <Button
                                className='cancelButtonn w-2 ml-3'
                                onClick={this.onHideAssignDialog}
                            >
                                <p className='cancelButtonnText'>Cancel</p>
                            </Button>
                        </div>

                    </div >
                </Dialog>


                <Dialog
                    visible={this.state.isRejectDialogOpen}
                    draggable={false}
                    closeOnEscape={false}
                    className='w-3'
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (<div className='formHeadingInter' style={{}}>

                            <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                        </div>)
                    }}
                    footer={() => (
                        <div className='flex justify-content-center '>
                            <Button className='formSubmitButton px-6' style={{ border: 0 }} onClick={this.deleteNotification} >
                                <p className='formSubmitButtonText'>Delete</p>
                            </Button>
                            <Button className='formCancelButton px-4' style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isRejectDialogOpen: false })} >
                                <p className='formCancelButtonText'>Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isRejectDialogOpen: false })}
                >
                    <div>
                        <p className='sideHeading' style={{ fontSize: 20 }}>{"Are you sure you want to delete?"}</p>

                    </div>

                </Dialog>

                <NotificationHistory
                    visible={this.state.notificationHistoryDialog}
                    selectedNotification={this.state.selectedNotification}
                    onHide={() => this.setState({ notificationHistoryDialog: false })}
                />

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <>
                    <LoadingComponent />
                </>}
            </div>
        )
    }


}


const mapStateToProps = (state) => ({
    getAllImagesUrlInfo: (state.getImageUrlInfo && state.getImageUrlInfo.allImageUrls) ? state.getImageUrlInfo.allImageUrls : {},
    emailConfig: state.orgData.emailConfig,
    smsConfig: state.orgData.smsConfig,
    whatsAppConfig: state.orgData.whatsAppConfig,
    orgData: state.orgData,
    permissionIds: state.currentUserPerms?.permissionIds,
    userInfo: state.currentUserPerms?.userInfo || {},
});

const mapDispatchToProps = (dispatch) => ({
    getImageUrl: (url) => dispatch(getImageUrl(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Authentication(withRouter(ComNotification)));

